export enum Framework {
  ac = 'ac',
  iab= 'iab',
}